import { useLang } from "@/context/LangContext";
import { LegalLayout, LEGAL_ENTITY, LEGAL_JURISDICTION, SUPPORT_EMAIL } from "./LegalLayout";

export default function Privacy() {
  const { lang } = useLang();
  const es = lang === "es";
  return (
    <LegalLayout title={es ? "Política de Privacidad" : "Privacy Policy"} updated={es ? "Última actualización: 2026" : "Last updated: 2026"}>
      <p>{es
        ? `${LEGAL_ENTITY} ("nosotros") respeta tu privacidad. Esta Política explica qué datos recopilamos y cómo los usamos al utilizar URBIS.`
        : `${LEGAL_ENTITY} ("we") respects your privacy. This Policy explains what data we collect and how we use it when you use URBIS.`}</p>

      <h2>{es ? "1. Datos que recopilamos" : "1. Data we collect"}</h2>
      <ul>
        <li>{es ? "Datos de cuenta: nombre, email, contraseña (cifrada), rol." : "Account data: name, email, password (hashed), role."}</li>
        <li>{es ? "Datos del negocio: nombre, categoría, dirección, logo, sucursales." : "Business data: name, category, address, logo, branches."}</li>
        <li>{es ? "Datos de clientes y facturas que tú introduces." : "Client and invoice data you enter."}</li>
        <li>{es ? "Datos de pago procesados por Stripe (no almacenamos números de tarjeta)." : "Payment data processed by Stripe (we do not store card numbers)."}</li>
        <li>{es ? "Datos de uso y cookies técnicas." : "Usage data and technical cookies."}</li>
      </ul>

      <h2>{es ? "2. Cómo usamos los datos" : "2. How we use data"}</h2>
      <p>{es ? "Para operar el Servicio, procesar pagos, enviar notificaciones y recibos, dar soporte y mejorar la plataforma." : "To operate the Service, process payments, send notifications and receipts, provide support and improve the platform."}</p>

      <h2>{es ? "3. Proveedores (encargados)" : "3. Service providers (processors)"}</h2>
      <ul>
        <li>Stripe — {es ? "procesamiento de pagos." : "payment processing."}</li>
        <li>Resend — {es ? "envío de correos transaccionales." : "transactional email delivery."}</li>
        <li>{es ? "Proveedores de IA (para el asistente de soporte)." : "AI providers (for the support assistant)."}</li>
      </ul>

      <h2>{es ? "4. Conservación" : "4. Retention"}</h2>
      <p>{es ? "Conservamos los datos mientras tu cuenta esté activa y según lo requiera la ley (p. ej. registros fiscales)." : "We retain data while your account is active and as required by law (e.g. tax records)."}</p>

      <h2>{es ? "5. Tus derechos" : "5. Your rights"}</h2>
      <p>{es ? "Puedes solicitar acceso, corrección o eliminación de tus datos escribiendo a " : "You may request access, correction or deletion of your data by writing to "}<a href={`mailto:${SUPPORT_EMAIL}`} className="text-primary">{SUPPORT_EMAIL}</a>.</p>

      <h2>{es ? "6. Seguridad" : "6. Security"}</h2>
      <p>{es ? "Aplicamos medidas razonables (cifrado de contraseñas, conexiones seguras). Ningún sistema es 100% seguro." : "We apply reasonable measures (password hashing, secure connections). No system is 100% secure."}</p>

      <h2>{es ? "7. Menores" : "7. Minors"}</h2>
      <p>{es ? "El Servicio no está dirigido a menores de 18 años." : "The Service is not directed to children under 18."}</p>

      <h2>{es ? "8. Ley aplicable y contacto" : "8. Governing law and contact"}</h2>
      <p>{es ? `Esta Política se rige por las leyes del ${LEGAL_JURISDICTION.es}. Contacto: ` : `This Policy is governed by the laws of the ${LEGAL_JURISDICTION.en}. Contact: `}<a href={`mailto:${SUPPORT_EMAIL}`} className="text-primary">{SUPPORT_EMAIL}</a></p>

      <p className="mt-8 rounded-sm bg-amber-50 p-3 text-xs text-amber-700">{es ? "Aviso: plantilla estándar. Revísala con un abogado antes de producción." : "Notice: standard template. Have it reviewed by an attorney before production."}</p>
    </LegalLayout>
  );
}
